import React from 'react';
import '../SharedControlPanel.scss';
import './TranscoderAudioPanel.scss';
import AudioBitrateInput from '../../../../InputComponents/AudioBitrateInput/AudioBitrateInput';
import AudioChannelInput from '../../../../InputComponents/AudioChannelInput/AudioChannelInput';
import AudioSampleRateInput from '../../../../InputComponents/AudioSampleRateInput/AudioSampleRateInput';

const TranscoderAudioPanel = () => {
  return (
    <div className="transcoder-audio-panel">
      <div className="transcoder-audio-panel-section level">
        <div className="transcoder-audio-panel-section-content-value">
          <AudioBitrateInput />
        </div>
      </div>

      <hr className="control-panel-section-divider" />

      <div className="transcoder-audio-panel-section level">
        <div className="transcoder-audio-panel-section-content-value">
          <AudioChannelInput />
        </div>
      </div>

      <hr className="control-panel-section-divider" />

      <div className="transcoder-audio-panel-section level">
        <div className="transcoder-audio-panel-section-content-value">
          <AudioSampleRateInput />
        </div>
      </div>
    </div>
  );
};

export default React.memo(TranscoderAudioPanel);
